import { ServicesService } from './../../../services/servicesService';
import { Router } from '@angular/router';

import { Component, OnInit, Input } from '@angular/core';

import { NbDialogService } from '@nebular/theme';
import { BaseComponent } from '../../../../../shared/Components/base/base.component';
import { ServicesRatesService } from '../../../services/servicesRatesService';
import { PagingService } from '../../../../../shared/Services/PagingService';
import { AddRateCategoryComponent } from '../add-rate/add-rate-category.component';
import { UpdateRateCategoryComponent } from '../update-rate/update-rate-category.component';

@Component({
  selector: 'ngx-service-rates',
  templateUrl: './service-rates.component.html',
  styleUrls: ['./service-rates.component.scss'],
})
export class ServiceRatesComponent extends BaseComponent implements OnInit {
  @Input() servicesId: number;
  @Input() categories: any[];
  constructor(
    public service: ServicesRatesService,
    public paging: PagingService,
    public route: Router,
    private ser: ServicesService,
    private diag: NbDialogService
  ) {
    super(route, service, paging);
  }

  ngOnInit(): void {
    // this.service.getData('service/' + this.servicesId).subscribe((res) => {
    //   this.categories = res;
    //   this.finishLoading = true;
    // });
    // this.loadEntities();
  }

  addCategory() {
    this.diag.open(AddRateCategoryComponent, { context: { serviceId: this.servicesId } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.ser.getById(this.servicesId).subscribe((resp) => {
          this.categories = resp.ratesCategories;
        });
      }
    });
  }
  deleteItem(id) {
    this.service.delete(id).subscribe((res) => {
      this.ser.getById(this.servicesId).subscribe((resp) => {
        this.categories = resp.ratesCategories;
      });
    });
  }
  update(serviceRate) {
    this.diag.open(UpdateRateCategoryComponent, { context: { serviceRate: serviceRate } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.ser.getById(this.servicesId).subscribe((resp) => {
          this.categories = resp.ratesCategories;
        });
      }
    });
  }
}
